import { Constants } from './constants';
import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateTimeFormat'
})
export class DateTimeFormatPipe extends DatePipe implements PipeTransform {
  transform(value: any, args?: any): any {
    //value= value.substr(3,2);

    let date: Date = new Date(value);
    let date1: string = date.toDateString()
    date1 = date1.substr(0, 3);
    return date1;
  }
}